// 高速通用工具
import Vue from 'vue';
/**
 * 递归查找menu中的名称
 * @param routeName 路由名称
 * @returns {string|*}
 */
export const findTitleByRouteName = routeName =>{
  const cache = sessionStorage.getItem('menu') || localStorage.getItem('menu');
  if (!cache) {
    return '';
  }
  const menu = JSON.parse(cache);

  function find(name, menuList) {
    for (const m of menuList) {
      if (!m.children) {
        if (m.path.includes(name)) {
          return m.title;
        }
      } else {
        const result = find(name, m.children);
        if (result) {
          return result;
        }
      }
    }
  }

  return find(routeName, menu);
}

window.expressway = {
  findTitleByRouteName,
};

Vue.prototype.$expressway = window.expressway
